<template>
    <div class="personal-profile-section" :class="{ 'blocked' : editMode && !editable , 'opened' : editable }">
        <span class="personal-profile-section-title">Пароль <span v-if="!editable" class="link ml-auto"
                                                                  @click.prevent="editSection('password')">Изменить</span></span>
        <div v-if="!editable" class="row q-col-gutter-md">
            <div class="col-12 col-sm-4">
                <q-input type="password"
                         dense
                         square
                         disable
                         filled
                         :value="passwordMask">
                </q-input>
            </div>
            <div class="col-12 col-sm-4">
                <q-input type="password"
                         dense
                         square
                         disable
                         filled
                         :value="passwordMask">
                </q-input>
            </div>
        </div>
        <div v-if="editable" class="row q-col-gutter-md">
            <div class="col-12 col-sm-4">
                <q-input
                    dense
                    square
                    label="Новый пароль"
                    v-model="form.password"
                    outlined
                    :type="passwordType ? 'password' : 'text'"
                    :error-message="form.errors.get('password')"
                    :error="form.errors.has('password')"
                    @keydown="form.errors.clear('password')">
                    <template v-slot:append>
                        <q-icon
                            :name="passwordType ? 'visibility_off' : 'visibility'"
                            class="cursor-pointer"
                            @click="passwordType = !passwordType"/>
                    </template>
                </q-input>
            </div>
            <div class="col-12 col-sm-4 mb-3 pr-lg-3 mb-lg-0">
                <q-input
                    dense
                    square
                    label="Подтвердить"
                    v-model="form.password_confirmation"
                    outlined
                    :type="passwordConfirmationType ? 'password' : 'text'"
                    :error-message="form.errors.get('password_confirmation')"
                    :error="form.errors.has('password_confirmation')"
                    @keydown="form.errors.clear('password_confirmation')">
                    <template v-slot:append>
                        <q-icon
                            :name="passwordConfirmationType ? 'visibility_off' : 'visibility'"
                            class="cursor-pointer"
                            @click="passwordConfirmationType = !passwordConfirmationType"
                        />
                    </template>
                </q-input>
            </div>
        </div>
        <div v-if="editable" class="q-gutter-sm ml-auto">
            <q-btn outline @click="cancelEditing" label="Отменить"></q-btn>
            <q-btn color="primary" @click="sendConfirmation" label="Сохранить"></q-btn>
        </div>
        <q-dialog v-model="confirmationModal"
                  transition-show="scale"
                  transition-hide="scale"
                  :maximized="$q.platform.is.mobile">
            <q-card class="modal modal-40">
                <div class="modal-header">
                    <span class="modal-title">Подтверждение</span>
                    <div class="modal-close" @click="confirmationModal = false">
                        <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px"
                                 viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                                <path fill=""
                                      d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                            </svg>
                        </span>
                    </div>
                </div>
                <q-card-section class="modal-content">
                    <div class="q-mt-sm">
                        <div class="row q-col-gutter-none q-gutter-y-md">
                            <div class="col-12">
                                Мы отправили вам СМС с кодом подтверждения на номер {{ form.phone_number }}
                            </div>

                            <div class="col-12">
                                <q-input
                                    square
                                    outlined
                                    dense
                                    v-model="codeForm.code"
                                    @keydown="codeForm.errors.clear('code')"
                                    :error-message="codeForm.errors.get('code')"
                                    :error="codeForm.errors.has('code')" />
                            </div>

                            <div class="col-12">
                                <q-btn class="full-width" label="Отправить" @click.prevent="confirm"/>
                            </div>

                            <div class="col-12 q-mt-md">
                                <template v-if="!countdownFinished">
                                    <span>Повторная отправка смс возможна через: </span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px">
                                        <path fill="currentColor"
                                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                                    </svg>
                                    <span>{{ countdownMinutesWithLeadingZeroLeft }}</span> :
                                    <span>{{ countdownSecondsWithLeadingZeroLeft }}</span>
                                </template>

                                <template v-else>
                                    <q-btn outline
                                           class="full-width text-primary outline-primary"
                                           label="Отправить код повторно"
                                           @click.prevent="sendConfirmation" />
                                </template>
                            </div>
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import {Form} from '../../classes/Form';
import countdown from "../../mixins/countdown";

export default {
    name: 'CustomerPassword',
    props: {
        mask: {
            type: String,
            required: true
        },
    },
    mixins: [
        countdown
    ],
    data: function () {
        return {
            confirmationModal: false,
            passwordMask: '',
            passwordType: true,
            passwordConfirmationType: true,
            resendCodeDelay: 2, // in minutes
            form: new Form({
                password: '',
                password_confirmation: '',
            }),
            codeForm: new Form({
                code: '',
            })
        };
    },
    mounted: function () {
        let _this = this;

        _this.passwordMask = _this.mask;
    },
    methods: {
        ...mapMutations('customer', [
            'editSection',
            'cancelEditing',
        ]),

        sendConfirmation() {
            this.form.put('/account/password/send-confirmation')
                .then(response => {
                    if (response.status === 'success') {
                        this.confirmationModal = true;

                        this.setCountdownEndTimestamp((new Date()).getTime() + (this.resendCodeDelay * 60000));
                    } else {
                        alert('Что-то пошло не так... Повторите попытку позднее или свяжетесь с администратором');
                    }
                });
        },

        confirm() {
            this.codeForm.put('/account/password/change')
                .then(response => {
                    if (response.status === 'success') {
                        this.confirmationModal = false;

                        this.passwordMask = response.passwordMask;

                        this.cancelEditing();

                        this.form.reset();
                        this.codeForm.reset();
                    } else {
                        alert('Что-то пошло не так... Повторите попытку позднее или свяжетесь с администратором');
                    }
                });
        }
    },
    computed: {
        ...mapGetters('customer', {
            editMode: 'editMode',
            editableSection: 'editable'
        }),

        editable: function () {
            return this.editableSection('password');
        },
    },
}
</script>
